import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activities: [],
    tags: [],
    activity: {},
    comments: [],
    token: localStorage.getItem('token') || '',
    user: {}
  },
  getters: {
    token: state => state.token,
    user: state => state.user,
    activities: state => state.activities,
    tags: state => state.tags,
    activity: state => state.activity,
    comments: state => state.comments
  },
  mutations: {
    setToken: (state, token) => (state.token = token),
    setUser: (state, user) => (state.user = user),
    setActivities: (state, activities) => (state.activities = activities),
    setTags: (state, tags) => (state.tags = tags),
    setActivity: (state, activity) => (state.activity = activity),
    setComments: (state, comments) => (state.comments = comments)
  },
  actions: {
    async fetchToken({ dispatch, commit }, payload) {
      const response = await axios.post('/auth/login/', payload)

      let token = response.data.key
      localStorage.setItem('token', token)
      commit('setToken', token)
      await dispatch('fetchUser')
    },
    async logout({ commit }) {
      await axios.post('/auth/logout/')

      localStorage.removeItem('token')
      commit('setToken', '')
    },
    async fetchUser({ commit }) {
      const response = await axios.get('/auth/user/')

      commit('setUser', response.data)
    },
    async fetchActivities({ commit }) {
      const response = await axios.get('/activities/')

      commit('setActivities', response.data);
    },
    async fetchTags({ commit }) {
      const response = await axios.get('/tags/')

      commit('setTags', response.data.results);
    },
    async fetchActivity({ commit }, id) {
      const response = await axios.get(`/activities/${id}/`)

      commit('setActivity', response.data)
    },
    async fetchComments({ commit }, activityId) {
      try {
        const response = await axios.get(`/activities/${activityId}/comments`)

        commit('setComments', response.data)
      } catch (error) {
        if (error.response) {
          commit('setComments', error.response.status)
        } else if (error.request) {
          commit('setComments', error.request.status)
        } else {
          console.log('Error', error.message);
        }
      }
    }
  },
  modules: {
  }
})
